module.exports = __webpack_public_path__ + "img/05.bb4fc7cb.jpg";